import _ from 'lodash'

export function merge () {
  return _.merge({}, ...arguments)
}



// WEBPACK FOOTER //
// ./src/components/profile/utils.js